import { Spacing } from '@persona-id/design-tokens';
import { SearchIcon } from '@persona-id/design-tokens/icons';
import { ChangeEvent, useMemo } from 'react';
import styled from 'styled-components';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { ThemeSetsFilterParams } from 'dashboard/redux/thunk-actions/theme-sets';
import Card from 'design-system/components/Card';
import Input, { InputGroup } from 'design-system/components/Input';
import Select, { Option } from 'design-system/components/Select';
import useDebounced from 'lib/hooks/useDebounced';

const SORT_OPTIONS = [
  {
    label: 'Name A to Z',
    value: 'name',
  },
  {
    label: 'Name Z to A',
    value: '-name',
  },
  {
    label: 'Created new to old',
    value: '-created_at',
  },
  {
    label: 'Created old to new',
    value: 'created_at',
  },
  {
    label: 'Edited new to old',
    value: '-updated_at',
  },
  {
    label: 'Edited old to new',
    value: 'updated_at',
  },
];

const FiltersRow = styled('div')`
  display: grid;
  column-gap: ${Spacing[4]};
  grid-template-columns: 3fr 1fr;
  align-items: end;
`;

interface ThemeSetsViewConfigurationBarProps {
  indexFilter: ThemeSetsFilterParams;
  handleOmniUpdate: (omni: string) => void;
  handleSortUpdate: (newSortParams: SortParams) => void;
}

const ThemeSetsViewConfigurationBar = ({
  indexFilter,
  handleOmniUpdate,
  handleSortUpdate,
}: ThemeSetsViewConfigurationBarProps) => {
  const { sort, shouldSortDescending } = indexFilter.sortParams;

  const themeSetSortParamsByString = useMemo(
    () => `${shouldSortDescending ? '-' : ''}${sort}`,
    [sort, shouldSortDescending],
  );

  const updateSortParms = (input: string) => {
    handleSortUpdate({ sort: input, shouldSortDescending: false });
  };

  const [handleOmniFilterChange] = useDebounced(
    (e: ChangeEvent<HTMLInputElement>) => handleOmniUpdate(e.target.value),
    350,
  );

  return (
    <Card>
      <Card.Body>
        <FiltersRow>
          <div>
            <FormControlLabel htmlFor='theme-sets-view-configuration-bar__filter-omni'>
              Search
            </FormControlLabel>
            <InputGroup leftIcon={<SearchIcon />}>
              <Input
                id='theme-sets-view-configuration-bar__filter-omni'
                placeholder='Theme name'
                size='md'
                defaultValue={indexFilter.omni}
                onChange={handleOmniFilterChange}
              />
            </InputGroup>
          </div>
          <div>
            <FormControlLabel htmlFor='theme-sets-view-configuration-bar__select--sort'>
              Sort By
            </FormControlLabel>
            <Select
              id='theme-sets-view-configuration-bar__select--sort'
              value={themeSetSortParamsByString}
              onValueChange={updateSortParms}
            >
              {SORT_OPTIONS.map((option, i) => (
                <Option key={i} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </div>
        </FiltersRow>
      </Card.Body>
    </Card>
  );
};

export default ThemeSetsViewConfigurationBar;
